import React from "react";
import PropTypes from 'prop-types';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { makeStyles } from "@material-ui/core/styles";

export default function ModalWarning(props) {

  const useStyles = makeStyles(() => ({
    warningbox: {
      backgroundColor: 'rgb(255, 176, 176)',
      marginTop: '2rem',
      marginBottom: '2rem',
      borderRadius: '4px',
      padding: '6px 16px',
      fontSize: '14px',
      lineHeight: '1.1rem',
      maxWidth: '448px',
    },
    message: {
      fontWeight: 'lighter',
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.warningbox}>
      <span className={classes.message}>{props.message}</span>
    </div>
  )
}

ModalWarning.propTypes = {
  message: PropTypes.string.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Widgets/ModalWarning.js